import type { AreaId, Me } from '../api/types'
import { permittedAreas } from '../areas/areas'

// In-memory only (GAP-DD-022): which area the user last worked in, for area-less pages
// such as /account. Lost on reload, which is fine.
let lastArea: AreaId | null = null

export function rememberArea(area: AreaId): void {
  lastArea = area
}

export function currentArea(me: Me): AreaId | null {
  const areas = permittedAreas(me)
  if (lastArea && areas.includes(lastArea)) return lastArea
  return areas[0] ?? null
}
